export default __webpack_public_path__ + "static/media/SH-Tower_Plan.f7c10735.pdf";